import { render, staticRenderFns } from "./virtualCardConfiguration.vue?vue&type=template&id=622b1b0d&"
import script from "./virtualCardConfiguration.vue?vue&type=script&lang=js&"
export * from "./virtualCardConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./virtualCardConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports